import * as Yup from 'yup'
import { SegmentoNotificacaoType } from '_metronic/helpers'

export const notificacaoEnviarSchema = Yup.object().shape({
  titulo: Yup.string().required('Título é obrigatório'),
  texto: Yup.string().required('Mensagem é obrigatória'),
  categoria: Yup.object().nullable().required('Categoria é obrigatória'),
  segmento: Yup.object().nullable().required('Segmento é obrigatório'),

  pessoas: Yup.array().when('segmento.value', {
    is: SegmentoNotificacaoType.Lista,
    then: (schema) => schema.min(1, 'Selecione ao menos uma pessoa'),
    otherwise: (schema) => schema.notRequired(),
  }),

  criterioAtendimento: Yup.object()
    .nullable()
    .when('segmento.value', {
      is: SegmentoNotificacaoType.Atendimento_Aberto,
      then: (schema) => schema.required('Critério de atendimento é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),
})
